/** @format */

import { Chain, Environment } from '@shared/data-access/interfaces';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GTGTEngineDao {
  private readonly DEFAULT_HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
    Pragma: 'no-cache',
    Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
  };

  private readonly HTTP_HEADERS = new HttpHeaders(this.DEFAULT_HEADERS);

  private readonly chain = inject(Chain);
  private readonly environment = inject(Environment);
  private readonly http = inject(HttpClient);

  public static handleError(error: HttpErrorResponse | any) {
    // return an ErrorObservable
    return throwError(error);
  }

  public getSkuEligibility$(sku: string): Observable<any> {
    const url = `${this.environment.api.gtgt.basePath}/${this.chain.storeId}/${sku}`;

    const httpOptions = {
      headers: this.HTTP_HEADERS,
      withCredentials: true,
    };

    return this.http.get(url, httpOptions).pipe(catchError(GTGTEngineDao.handleError));
  }
}
